import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import styled, { css } from 'styled-components';

const localVariables = {
    imageCellSize: '80px',
} as const;

type ProductPriceType = {
    isOldPrice?: boolean;
    isSpecialPrice?: boolean;
};

export const ImageCellStyled = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        width: ${localVariables.imageCellSize};
        padding-right: 20px;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            margin-bottom: 15px;
        }
    `}
`;

export const ImageWrapperStyled = styled(ExtendedNextLink)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${localVariables.imageCellSize};
    height: ${localVariables.imageCellSize};
`;

export const InfoCellStyled = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        margin-right: 15px;
        text-align: center;
        flex: 1;

        font-size: 13px;
        font-weight: 700;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            flex: auto;
            width: calc(100% - ${localVariables.imageCellSize});
            align-items: flex-start;
            flex-direction: column;
            margin-bottom: 5px;
            margin-right: 0;
        }
    `}
`;

export const ItemPriceCellStyled = styled.div`
    ${({ theme }) => css`
        width: 130px;
        margin-right: 15px;
        font-size: 16px;
        text-align: right;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            display: none;
        }
    `}
`;

export const MobileItemPriceStyled = styled.span(
    ({ theme }) => css`
        @media ${theme.mediaQueries.queryVl} {
            display: none;
        }
    `,
);

export const TotalPriceCellStyled = styled.div`
    ${({ theme }) => css`
        width: 135px;
        margin-right: 25px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: right;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            flex-direction: column;
            align-items: flex-end;
            margin-left: auto;
            margin-right: 0;
        }
    `}
`;

export const RemoveButtonCellStyled = styled.div`
    ${({ theme }) => css`
        position: static;
        align-items: center;
        display: flex;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            position: absolute;
            top: 20px;
            right: 0;
        }
    `}
`;

export const AddToCartPriceStyled = styled.div<ProductPriceType>(
    ({ theme, isOldPrice, isSpecialPrice }) => css`
        line-height: 20px;

        font-size: 18px;
        font-weight: 700;
        color: ${theme.color.primary};

        ${isOldPrice &&
        css`
            line-height: 14px;

            font-size: 14px;
            font-weight: 500;
            color: ${theme.color.primary};
            text-decoration-line: line-through;
            text-decoration-color: ${theme.color.red};
        `}

        ${isSpecialPrice &&
        css`
            color: ${theme.color.red};
        `}
    `,
);

export const AddToCartSavedAmountStyled = styled.div(
    ({ theme }) => css`
        display: inline-block;
        padding: 3px 4px;
        margin: 4px 0;
        line-height: 1.25;

        background-color: ${theme.color.red};
        color: ${theme.color.white};
        font-size: 12px;
    `,
);

export const ItemCouponStyled = styled.span(
    ({ theme }) => css`
        font-size: 12px;
        font-weight: 700;
        color: ${theme.color.red};
    `,
);
